import React, {Component} from "react";
import {connect} from "react-redux";

import {auth} from "../actions";

import logo from "../images/_acerca_industrial_l.png"

import {
    Button,
    Card,
    Col,
    Container,
    Form,
    FormInput,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    ListGroup,
    ListGroupItem,
    Row
} from "shards-react";
import {Redirect} from "react-router-dom";

/**
 * Clase que representa el componente de inicio de sesión.
 * @class
 * @extends Component
*/
// const Login = () => (
class Login extends Component {
/**
 * Estado del componente.
 * @property {string} username - Nombre de usuario.
 * @property {string} password - Contraseña del usuario.
*/
    state = {
        username: "",
        password: "",
    };
/**
 * Método que se ejecuta al enviar el formulario.
 * @param {Event} e - Evento del formulario.
*/
    onSubmit = e => {
        e.preventDefault();
        this.props.login(this.state.username, this.state.password);

        // console.log(this.state);
    };
/**
 * Método que se encarga de renderizar el componente.
 * @returns {JSX.Element} - Elemento JSX que representa el componente.
*/
    render() {
        if (this.props.isAuthenticated) {
            return <Redirect to="/" />
        }
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <h1 className="ml-lg-auto mr-lg-auto ml-md-auto mr-md-auto ml-sm-auto mr-sm-auto ml-xs-auto mr-xs-auto text-center"><img src={logo} alt="Acerca Industrial"/></h1>

                </Row>
                <Row>
                    <Col lg="12">
                        <Card small className="mb-4">
                            <ListGroup flush>
                                <ListGroupItem className="p-3">
                                    <Row>
                                        <Col>
                                            <Form onSubmit={this.onSubmit}>
                                                <Row form>
                                                    {/* Email */}
                                                    <Col lg="12">
                                                        <InputGroup seamless className="mb-3">
                                                            <InputGroupAddon type="prepend">
                                                                <InputGroupText>
                                                                    <i className="material-icons">person</i>
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <FormInput
                                                                type="text"
                                                                id="username"
                                                                placeholder="Correo"
                                                                onChange={e => this.setState({username: e.target.value})}
                                                                autoComplete="username"
                                                            />
                                                        </InputGroup>
                                                    </Col>

                                                    {/* Password */}
                                                    <Col lg="12">
                                                        <InputGroup seamless className="mb-3">
                                                            <InputGroupAddon type="prepend">
                                                                <InputGroupText>
                                                                    <i className="material-icons">lock</i>
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <FormInput
                                                                type="password"
                                                                id="Password"
                                                                placeholder="Contraseña"
                                                                onChange={e => this.setState({password: e.target.value})}
                                                                autoComplete="current-password"
                                                            />
                                                        </InputGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="12">
                                                        {this.props.errors.length > 0 && (
                                                            <ul>
                                                                {this.props.errors.map(error => (
                                                                    <li key={error.field}>{error.message}</li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="12" className="my-2">
                                                        <Button theme="accent" className="btn-block btn btn-primary">Iniciar Sesión</Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}
/**
 * Función que mapea el estado a las props del componente
 * @param {Object} state - Estado actual de la aplicación
 * @returns {Object} - Objeto que contiene las props mapeadas al estado
*/
const mapStateToProps = state => {
    let errors = [];
    if (state.auth.errors) {
        errors = Object.keys(state.auth.errors).map(field => {
            return {field, message: state.auth.errors[field]};
        });
    }
    return {
        errors,
        isAuthenticated: state.auth.isAuthenticated
    };
};
/**
 * Función que mapea las acciones a las props del componente
 * @param {Function} dispatch - Función de redux para despachar acciones
 * @returns {Object} - Objeto que contiene las props mapeadas a las acciones
*/
const mapDispatchToProps = dispatch => {
    return {
        login: (username, password) => {
            return dispatch(auth.login(username, password));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
